/**
 *  Slider
 *  Use jQuery & Owl Carrousel
 */

;(function slider($) {

    $(document).ready(init);

    var CONTAINER_SEL = '.js-Slider';
    var NAVITEM_SEL = '.js-Slider-nav > li';
    var container;

    function init() {
        container = $(CONTAINER_SEL);
        var options = {
            animation: 'slide',
            animationSpeed: 1000,
            slideshowSpeed: 3500,
            controlNav: false,
            directionNav: false
        };

        if (container.length) {
            if (container.attr('data-nav') === 'active') {
                options.controlNav = true;
                options.manualControls = NAVITEM_SEL;
                options.namespace = 'Hero-navItem--';
            }
            if (container.attr('data-time')) {
                options.slideshowSpeed = parseInt(container.attr('data-time'), 10);
            }
            container.flexslider(options);
        }
    }

}(jQuery));
